<div class="d-flex flex-column" *ngIf="isDataLoaded && enableAppConfig && enableImgConfig">
    <div *ngIf="showNavbarOnRoutes" class="sticky-top header-primary"  >
        <app-header  [loggedIn]="loggedIn"></app-header>
    </div>
    <div class="routing-content" [ngClass]="{'content-primary':showNavbarOnRoutes}">
        <router-outlet></router-outlet>
    </div>
    
</div>